import type {DownloadListItem} from "~/components/download/types";

export default {
    name: "XSQUARE REPORTS",
    stats: {
        "Version": "5.0.0.12",
        // "File size":  "5.9 MB",
        "Update": "May 15, 2025"
    },
    descriptionTitle: "",
    description: "",
    buttons: {
        "Download" : "https://xsquare.dev/files/edu/"
    }
} as DownloadListItem
